import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL;

let onTokenExpiredCallback = null;

export const setOnTokenExpiredCallback = (callback) => {
  onTokenExpiredCallback = callback;
};

export const apiCall = async (url, data = {}, token, method = 'POST') => {
  try {
    const config = {
      method: method.toLowerCase(), // 'get', 'post', etc.
      url: `${API_BASE_URL}${url}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    // Attach data for POST/PUT/PATCH, and params for GET
    if (['post', 'put', 'patch'].includes(config.method)) {
      config.data = data;
    } else if (config.method === 'get') {
      config.params = data;
    }

    const response = await axios(config);

    if (response.code === 200 ) {
      return response.data;
    } else {
      // throw new Error('API call failed with status: ' + response.status);
      return response.data;
    }
  } catch (error) {
    // console.error("API error:", error);

    if (error.response?.data?.message === "Invalid token") {
      if (typeof onTokenExpiredCallback === 'function') {
        onTokenExpiredCallback();
      }
      return;
    }

    // throw error;
  }
};
